import { useQuery } from '@tanstack/react-query';

import { useHttpClient } from '@bonusly/http-client';

import { CollaborativeDocumentData } from '../../../types/collaborative-document';

export const useCollaborativeDocument = (meetingId: string | undefined) => {
	const http = useHttpClient('v2');

	return useQuery<CollaborativeDocumentData>(
		['collaborative-document', 'meeting', meetingId],
		async () => {
			if (!meetingId) {
				throw new Error('Meeting ID is required');
			}

			const response = await http.get<CollaborativeDocumentData>(`one_on_ones/meetings/${meetingId}/collaborative_document`);
			return response.data;
		},
		{
			enabled: !!meetingId,
			staleTime: Infinity,
			cacheTime: 30 * 60 * 1000, // Keep in cache for 30 minutes
		}
	);
};
